import React, { useMemo, useState } from "react";
import {
  Box,
  Chip,
  DialogContent,
  Grid,
  LinearProgress,
  Paper,
  Typography,
  Tooltip,
  Stack,
} from "@mui/material";
import {
  DialogComponent,
  PaginationTable,
  TextIconButtonComponent,
} from "../../../atom";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import { REGISTRED_COURSE_STATUS, THEME_COLORS } from "../../../../core/Constant";
import _ from "lodash";
import AdminStudentEditCourseForm from "./AdminStudentEditCourseForm";
import moment from "moment";

const AdminViewCoursesForm = ({ onclickcancel, studentDetails, stdSearchQuery }) => {
  const [openEditCourse, setOpenEditCourse] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");


  const handleEditCourse = (value, tableMeta) => {
    const selectedCourseId = value?.rowData?.[0];
    const selectedCourse = studentDetails?.course_progress?.find(
      (course) => course?.id?.toString() === selectedCourseId?.toString(),
    );
    setSelectedCourse(selectedCourse);
    setOpenEditCourse(true);
  };

  const columns = [
    { name: "id", label: "#", options: { filter: true, sort: false } },
    {
      name: "course",
      label: "Course Name",
      options: {
        filter: true,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const courses = [value?.name];

          if (!courses.length) return "-";

          return (
            <Box width={"200px"}>
              <Box>
                {courses.map((item, idx) => {
                  const courseName = item || "Unnamed Course";
                  const needsTooltip = courseName?.length > 50;
                  const displayedText = needsTooltip
                    ? `${courseName?.substring(0, 50)}...`
                    : courseName;

                  return (
                    <Typography 
                     component={"span"} 
                     key={`${tableMeta?.rowIndex}-${item?.course?.id || idx}`}>
                      {needsTooltip ? (
                        <Tooltip title={courseName} placement="top" arrow>
                          <span style={{ cursor: "pointer" }}>
                            {displayedText}
                          </span>
                        </Tooltip>
                      ) : (
                        displayedText
                      )}
                    </Typography>
                  );
                })}
              </Box>
            </Box>
          );
        },
      },
    },
    {
      name: "prices",
      label: "Plan Type",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const enrolledPlan = value?.find((plan)=> plan?.is_enrolled )
          const planType = enrolledPlan?.plan_name || ""
                  const needsTooltip = planType?.length > 17
                  const displayedText = needsTooltip
                     ? `${planType?.substring(0, 17)}...`
                     : planType;
          if(displayedText){
             return (
            <Chip sx={{
                fontSize: "13px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 0.5,
                backgroundColor: "#FFF0E3",
                color: "#F57C00",
                border: "none",
              }} label={
                needsTooltip ? (
                 <Tooltip title={planType} placement="top" arrow>
                   <span style={{ cursor: "pointer" }}>
                     {displayedText}
                   </span>
                 </Tooltip>
               ) : (
                 displayedText
               )
              }  />
          );
          }
        },
      },
    },
    {
      name: "student_batch_month",
      label: "Batch",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const batchMonth = tableMeta?.rowData?.[3]
          const batchYear = tableMeta?.rowData?.[4]
          if(batchMonth && batchYear){
            const selectedBatch = `${moment().month(Number(batchMonth) - 1).format("MMMM")} ${batchYear}`
           return (
            <Chip
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 0.5,
                backgroundColor:  "#F3E8FF",
                color: "#8B35F4",
                border: "none",
              }}
              label={selectedBatch}
            />
          );
          }
        },
      },
    },
    {
      name: "student_batch_year",
      options: {
        display: false,
      },
    },
    {
      name: "registeredDate",
      label: "Registration Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const formattedDate = moment(value).format("D MMMM YYYY");
          return <Typography component={"span"}>{formattedDate}</Typography>;
        },
      },
    },
    {
      name: "course_expiry_date",
      label: "Expiry Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if(value){
            const formattedDate = moment(value).format("D MMMM YYYY");
            return <Typography component={"span"}>{formattedDate}</Typography>;
          }
        },
      },
    },
    {
      name: "progress",
      label: "Progress",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta?.rowData?.[8] || ""
          if(status === REGISTRED_COURSE_STATUS.REGISTRED){
           return (
            <Stack spacing={1}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LinearProgress
                  variant="determinate"
                  value={value || 0}
                  sx={{ width: "100%", marginRight: 1 }}
                />
                <span>{`${Math.round(value || 0)}%`}</span>
              </Box>
            </Stack>
          );
          }
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <Typography component={"span"}>{ value === 1 ? "Active" : "Inactive"  } </Typography>
        },
      },
    },
    {
      name: "id",
      label: "Edit",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const isFree = tableMeta?.rowData?.[10]
         return (
          <Box sx={{ minWidth: 80, maxWidth: 80 }}>
            <TextIconButtonComponent
              btnText={"Edit"}
              disabled={isFree === 1}
              onclick={() => handleEditCourse(tableMeta)}
            />
          </Box>
         )
        }
      },
    },
    {
      name: "is_free",
      label: "is_free",
      options:{
        display: false,
      }
    }
  ];

  const filteredData = useMemo(() => {
    const data = studentDetails?.course_progress || [];

    if (!searchQuery) return data;

    return data.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    );
  }, [studentDetails,studentDetails?.course_progress, searchQuery]);
  const totalItems = filteredData.length;

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, rowsPerPage]);

  return (
    <Box p={1}>
      {studentDetails && (
        <DialogContent>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: "#FCF8FF",
              borderRadius: 3,
              border: "1px solid #E7D5FF",
              mb: 4,
            }}
          >
            <Grid container spacing={4}>
              <Grid item xs={1}>
                <Typography fontWeight={700}>ID</Typography>
                <Typography fontSize={16} component={"span"}>{studentDetails?.id}</Typography>
              </Grid>

              <Grid item xs={2}>
                <Typography fontWeight={700}>First Name</Typography>
                <Typography fontSize={16} component={"span"}>{studentDetails?.first_name}</Typography>
              </Grid>

              <Grid item xs={2}>
                <Typography fontWeight={700}>Last Name</Typography>
                <Typography fontSize={16} component={"span"}>{studentDetails?.last_name}</Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography fontWeight={700}>Email</Typography>
                <Typography fontSize={16} component={"span"}>{studentDetails?.email}</Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography fontWeight={700}>WhatsApp Number</Typography>
                <Typography fontSize={16} component={"span"}>{studentDetails?.whatsapp_phone_number}</Typography>
              </Grid>
            </Grid>
          </Paper>

          <Typography
            fontWeight={"bold"}
            variant="h5"
            color={THEME_COLORS.primary}
            mb={3}
          >
            Course Enrollment Details
          </Typography>

          <Box className="common-admin-content-wrap">
            <PaginationTable
              columns={columns}
              data={paginatedData}
              totalItems={totalItems}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              onPageChange={(page) => {
                setCurrentPage(page);
              }}
              onRowsPerPageChange={(perPage) => {
                setRowsPerPage(perPage);
                setCurrentPage(1);
              }}
              onSearchChange={(searchText) => {
                setSearchQuery(searchText);
              }}
              hideDownloadButton={true}
              filter={false}
              name={"Courses"}
            />
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={4}>
            <TextButtonComponet
              onButtonClick={onclickcancel}
              classStyle={"btn btn-secondary"}
              text={"Close"}
              style={{ minWidth: 80, maxWidth: 80 }}
            />
          </Box>
        </DialogContent>
      )}
      <DialogComponent
        title={"Edit Course Enrollment"}
        maxwidth="lg"
        children={
          <AdminStudentEditCourseForm
            course={selectedCourse}
            onclickcancel={() => setOpenEditCourse(false)}
            openEditCourse={openEditCourse}
            stdSearchQuery={stdSearchQuery}
          />
        }
        onClose={() => setOpenEditCourse(false)}
        open={openEditCourse}
      />
    </Box>
  );
};

export default AdminViewCoursesForm;
